
import {
  Component, Mixins,
} from 'vue-property-decorator';
import moment from 'moment';
import UtilsMixin from '@/mixins/UtilsMixin.vue';
import AttachmentWithStatus from '@/components/AttachmentWithStatus.vue';
import AttachmentsList from '@/components/AttachmentsList.vue';
import {
  Lead, BoxStatusType, BoxOutcomeType, Iter, User, AssignmentEntry,
} from '@/types';
import TaskStatusAlert from '@/components/TaskStatusAlert.vue';
import TaskActions from '@/components/TaskActions.vue';
import TaskActivityBox from '@/components/TaskActivityBox.vue';
import TaskOutcomeBox from '@/components/TaskOutcomeBox.vue';
import SwitchWithConfirm from '@/components/SwitchWithConfirm.vue';
import DatePickerDialog from '@/components/DatePickerDialog.vue';
import FullDatePickerDialog from '@/components/FullDatePickerDialog.vue';
import ConnectionLastStep from '@/components/connections/ConnectionLastStep.vue';
import MissingFinishings from '@/components/MissingFinishings.vue';
import {
  getLeadCustomValue,
  getLeadCustomValueBoolean, getLeadCustomValueText, getLeadCustomValueDate,
  taskFatherLead,
} from '@/helpers';
import CopyToClipboardIcon from '@/components/CopyToClipboardIcon.vue';
import Editor from '@/components/Editor.vue';
import AssignmentEntryItem from '@/components/AssignmentEntryItem.vue';
import OperationAssignmentsDialog from '@/components/OperationAssignmentsDialog.vue';
import TaskMixin from '@/mixins/TaskMixin.vue';

moment.locale('it');

@Component({
  components: {
    AttachmentsList,
    AttachmentWithStatus,
    TaskStatusAlert,
    TaskActions,
    SwitchWithConfirm,
    TaskActivityBox,
    TaskOutcomeBox,
    DatePickerDialog,
    FullDatePickerDialog,
    ConnectionLastStep,
    MissingFinishings,
    CopyToClipboardIcon,
    Editor,
    AssignmentEntryItem,
    OperationAssignmentsDialog,
  },
})
export default class TaskR extends Mixins(TaskMixin, UtilsMixin) {
  // Utilizzati nella v1 del Task R
  dicoElettrica: BoxStatusType = 'todo'
  dicoElettricaNotes: string | null | undefined = null
  visura: BoxStatusType = 'todo'
  visuraNotes: string | null | undefined = null
  autotest: BoxStatusType = 'todo'

  // Utilizzati nella v2 del Task R
  dicoVisuraCamerale: BoxStatusType = 'todo'
  dicoVisuraCameraleNotes: string | null | undefined = null
  inverter: BoxStatusType = 'todo'
  batteriaAC: BoxStatusType = 'todo'
  spiEsterna: BoxStatusType = 'todo'
  autotestNotes: string | null | undefined = null

  // Utilizzati in entrambe le versioni
  dicoElettricaDate: Date | null = null

  dicoTermica: BoxStatusType = 'todo'
  fGas: BoxStatusType = 'todo'
  registrazioneCriter: BoxStatusType = 'todo'

  fotoImpianto: BoxStatusType = 'todo'
  fotoDG: BoxStatusType = 'todo'
  fotoDGAlt: string | null = null
  fotoInverter: BoxStatusType = 'todo'
  fotoInverterAlt: string | null = null
  fotoBatteria: BoxStatusType = 'todo'
  fotoBatteriaAlt: string | null = null

  dicoTermicaNotes: string | null | undefined = null
  dicoTermicaDate: Date | null = null
  fGasNotes: string | null | undefined = null
  registrazioneCriterNotes: string | null | undefined = null
  fotoImpiantoNotes: string | null | undefined = null

  gse: string | null | undefined = null
  gseStatus1Date: Date | null = null
  gseStatus2Date: Date | null = null

  sal = false
  readyForSal1 = false
  readyForSal1Date: Date | null = null
  readyForSal2 = false
  readyForSal2Date: Date | null = null

  readyForFinalPayment = false
  readyForFinalPaymentDate: Date | null = null

  testingDate: Date | null = null
  testingDateConfirm = false
  testingOutcome: BoxOutcomeType = 'todo'
  testingNotes: string | null | undefined = null

  commissioningStatus: string | null = null
  commissioningDate: Date | null = null
  commissioningStartTime: string | null = null
  commissioningEndTime: string | null = null

  egridConnectionStatus: string | null = null
  egridConnectionDate: Date | null = null
  egridConnectionTime: string | null = null
  egridConnectionNotes: string | null | undefined = null
  egridDistributorAddress: string | null | undefined = null

  suggestedEgridConnectionDate1: Date | null = null
  suggestedEgridConnectionTime1: string | null = null
  suggestedEgridConnectionDate2: Date | null = null
  suggestedEgridConnectionTime2: string | null = null

  suggestedDate1AppendIcon: string | false = false
  suggestedDate2AppendIcon: string | false = false

  suggestedDate1Hint: string | null = null
  suggestedDate2Hint: string | null = null

  egridConnectionActiveDate: Date | null = null

  praticaEnea: BoxStatusType = 'todo'
  eneaPracticeDate: Date | null = null

  eneaElettricoNotes: string | null | undefined = null
  eneaTermicoNotes: string | null | undefined = null

  // ENEA assignment
  eneaAssigneeId: number | null = null
  eneaAssigned: string | null = null
  eneaAssignedDate: Date | null = null
  eneaAssignees: string | null = null
  editEneaAssignmentDialog = false

  praticaDogane: BoxStatusType = 'todo'
  doganeElettricoNotes: string | null | undefined = null

  // Dogane assignment
  doganeAssigneeId: number | null = null
  doganeAssigned: string | null = null
  doganeAssignedDate: Date | null = null
  doganeAssignees: string | null = null
  editDoganeAssignmentDialog = false

  internetConnectionTested = false
  serviceConfirm = false
  inverterConnected = false
  commissioningNotes: string | null | undefined = null

  missingFinishingsStatus: BoxStatusType | null = null;
  missingFinishingsNotes: string | null = null;

  datePickerDialog = false
  datePickerDate: string | null = null
  datePickerName: string | null = null

  fullDatePickerDialog = false

  timePickerDialog = false

  commissioningStatusValues = [
    {
      text: 'Data proposta',
      value: 'suggested',
    },
    {
      text: 'Data confermata',
      value: 'confirmed',
    },
    {
      text: 'Collaudo confermato',
      value: 'tested',
    },
  ]

  egridConnectionStatusValues = [
    {
      text: 'Data proposta',
      value: 'suggested',
    },
    {
      text: 'Data concordata (da confermare a portale)',
      value: 'not-confirmed',
    },
    {
      text: 'Data concordata (non necessaria conferma a portale)',
      value: 'no-confirmation-required',
    },
    {
      text: 'Data confermata',
      value: 'confirmed',
    },
    {
      text: 'Impianto in esercizio',
      value: 'connected',
    },
    {
      text: 'Allaccio KO da riprogrammare',
      value: 'ko',
    },
    {
      text: 'Non applicabile',
      value: 'na',
    },
  ]

  // Verbale di allaccio

  verbaleAllaccio: BoxStatusType = 'todo'

  // Fine lavori

  endOfWork: BoxStatusType = 'todo'
  endOfWorkNotes: string | null | undefined = null
  endOfWorkDate: Date | null = null

  apePost = false
  docsSentToPartner = false
  docsSentToCustomer = false

  titoloAutorizzativo: BoxStatusType = 'todo'

  operationId = this.father?.id ?? null;
  leadId = this.selectedLead?.id ?? null;
  showBusyDatesType: string | null | undefined = null;

  // Aggiorna solo i campi relativi agli assignment (ENEA e Dogane)
  // senza sovrascrivere le altre modifiche non salvate dell'utente.
  refreshAssignmentFields() {
    const leadAny = this.selectedLead as Record<string, unknown> | null;

    // ENEA assignment
    const eneaFromTopLevel = leadAny && ('eneaAssigneeId' in leadAny || 'eneaAssigned' in leadAny);
    const eneaAssigneeCV = getLeadCustomValue(this.selectedLead, 'eneaAssignee');
    this.eneaAssigneeId = eneaFromTopLevel && leadAny?.eneaAssigneeId != null
      ? Number(leadAny.eneaAssigneeId)
      : (eneaAssigneeCV?.userValueId ?? null);
    this.eneaAssigned = (eneaFromTopLevel && leadAny?.eneaAssigned != null
      ? leadAny.eneaAssigned
      : (getLeadCustomValueText(this.selectedLead, 'eneaAssigned') ?? 'todo')) as string;
    this.eneaAssignedDate = eneaFromTopLevel && leadAny?.eneaAssignedDate != null
      ? (leadAny.eneaAssignedDate as Date)
      : getLeadCustomValueDate(this.selectedLead, 'eneaAssignedDate');
    this.eneaAssignees = getLeadCustomValueText(this.selectedLead, 'eneaAssignees') ?? '[]';

    // Dogane assignment
    const doganeFromTopLevel = leadAny && ('doganeAssigneeId' in leadAny || 'doganeAssigned' in leadAny);
    const doganeAssigneeCV = getLeadCustomValue(this.selectedLead, 'doganeAssignee');
    this.doganeAssigneeId = doganeFromTopLevel && leadAny?.doganeAssigneeId != null
      ? Number(leadAny.doganeAssigneeId)
      : (doganeAssigneeCV?.userValueId ?? null);
    this.doganeAssigned = (doganeFromTopLevel && leadAny?.doganeAssigned != null
      ? leadAny.doganeAssigned
      : (getLeadCustomValueText(this.selectedLead, 'doganeAssigned') ?? 'todo')) as string;
    this.doganeAssignedDate = doganeFromTopLevel && leadAny?.doganeAssignedDate != null
      ? (leadAny.doganeAssignedDate as Date)
      : getLeadCustomValueDate(this.selectedLead, 'doganeAssignedDate');
    this.doganeAssignees = getLeadCustomValueText(this.selectedLead, 'doganeAssignees') ?? '[]';
  }

  // Aggiorna i campi con gli eventuali nuovi valori della Lead selezionata
  refreshTask() {
    console.log(`${this.constructor.name}: refreshTask()`); // eslint-disable-line no-console

    // Utilizzati nella v1 del Task R
    this.dicoElettrica = (getLeadCustomValueText(this.selectedLead, 'dicoElettrica') ?? 'todo') as BoxStatusType;
    this.dicoElettricaNotes = getLeadCustomValueText(this.selectedLead, 'dicoElettricaNotes');
    this.visura = (getLeadCustomValueText(this.selectedLead, 'visura') ?? 'todo') as BoxStatusType;
    this.visuraNotes = getLeadCustomValueText(this.selectedLead, 'visuraNotes');
    this.autotest = (getLeadCustomValueText(this.selectedLead, 'autotest') ?? 'todo') as BoxStatusType;

    // Utilizzati nella v2 del Task R
    this.dicoVisuraCamerale = (getLeadCustomValueText(this.selectedLead, 'dicoVisuraCamerale') ?? 'todo') as BoxStatusType;
    this.dicoVisuraCameraleNotes = getLeadCustomValueText(this.selectedLead, 'dicoVisuraCameraleNotes');
    this.inverter = (getLeadCustomValueText(this.selectedLead, 'inverter') ?? 'todo') as BoxStatusType;
    this.batteriaAC = (getLeadCustomValueText(this.selectedLead, 'batteriaAC') ?? 'todo') as BoxStatusType;
    this.spiEsterna = (getLeadCustomValueText(this.selectedLead, 'spiEsterna') ?? 'todo') as BoxStatusType;
    this.autotestNotes = getLeadCustomValueText(this.selectedLead, 'autotestNotes');

    // Utilizzati in entrambe le versioni
    this.dicoElettricaDate = getLeadCustomValueDate(this.selectedLead, 'dicoElettricaDate');

    this.dicoTermica = (getLeadCustomValueText(this.selectedLead, 'dicoTermica') ?? 'todo') as BoxStatusType;

    this.fGas = (getLeadCustomValueText(this.selectedLead, 'fGas') ?? 'todo') as BoxStatusType;
    this.registrazioneCriter = (getLeadCustomValueText(this.selectedLead, 'registrazioneCriter') ?? 'todo') as BoxStatusType;

    this.fotoImpianto = (getLeadCustomValueText(this.selectedLead, 'fotoImpianto') ?? 'todo') as BoxStatusType;
    this.fotoDG = (getLeadCustomValueText(this.selectedLead, 'fotoDG') ?? 'todo') as BoxStatusType;
    this.fotoDGAlt = getLeadCustomValueText(this.selectedLead, 'fotoDGAlt') ?? null;
    this.fotoInverter = (getLeadCustomValueText(this.selectedLead, 'fotoInverter') ?? 'todo') as BoxStatusType;
    this.fotoInverterAlt = getLeadCustomValueText(this.selectedLead, 'fotoInverterAlt') ?? null;
    this.fotoBatteria = (getLeadCustomValueText(this.selectedLead, 'fotoBatteria') ?? 'todo') as BoxStatusType;
    this.fotoBatteriaAlt = getLeadCustomValueText(this.selectedLead, 'fotoBatteriaAlt') ?? null;

    this.dicoTermicaNotes = getLeadCustomValueText(this.selectedLead, 'dicoTermicaNotes');
    this.dicoTermicaDate = getLeadCustomValueDate(this.selectedLead, 'dicoTermicaDate');
    this.fGasNotes = getLeadCustomValueText(this.selectedLead, 'fGasNotes');
    this.registrazioneCriterNotes = getLeadCustomValueText(this.selectedLead, 'registrazioneCriterNotes');
    this.fotoImpiantoNotes = getLeadCustomValueText(this.selectedLead, 'fotoImpiantoNotes');

    this.gse = getLeadCustomValueText(this.selectedLead, 'gse');
    this.gseStatus1Date = getLeadCustomValueDate(this.selectedLead, 'gseStatus1Date');
    this.gseStatus2Date = getLeadCustomValueDate(this.selectedLead, 'gseStatus2Date');

    this.sal = this.selectedLead?.sal ?? false;
    this.readyForSal1 = this.selectedLead?.readyForSal1 ?? false;
    this.readyForSal2 = this.selectedLead?.readyForSal2 ?? false;
    this.readyForFinalPayment = this.selectedLead?.readyForFinalPayment ?? false;
    this.readyForSal1Date = this.selectedLead?.readyForSal1Date ?? null;
    this.readyForSal2Date = this.selectedLead?.readyForSal2Date ?? null;
    this.readyForFinalPaymentDate = this.selectedLead?.readyForFinalPaymentDate ?? null;

    this.testingDate = getLeadCustomValueDate(this.selectedLead, 'testingDate');
    this.testingDateConfirm = getLeadCustomValueBoolean(this.selectedLead, 'testingDateConfirm') ?? false;
    this.testingOutcome = (this.selectedLead?.testingOutcome ?? 'todo') as BoxOutcomeType;
    this.testingNotes = getLeadCustomValueText(this.selectedLead, 'testingNotes');

    this.egridConnectionStatus = getLeadCustomValueText(this.selectedLead, 'egridConnectionStatus');
    this.egridConnectionDate = getLeadCustomValueDate(this.selectedLead, 'egridConnectionDate');
    this.egridConnectionTime = getLeadCustomValueText(this.selectedLead, 'egridConnectionTime');
    this.egridConnectionNotes = getLeadCustomValueText(this.selectedLead, 'egridConnectionNotes');
    this.egridDistributorAddress = getLeadCustomValueText(this.selectedLead, 'egridDistributorAddress');

    this.suggestedEgridConnectionDate1 = getLeadCustomValueDate(this.selectedLead, 'suggestedEgridConnectionDate1');
    this.suggestedEgridConnectionTime1 = getLeadCustomValueText(this.selectedLead, 'suggestedEgridConnectionTime1');
    this.suggestedEgridConnectionDate2 = getLeadCustomValueDate(this.selectedLead, 'suggestedEgridConnectionDate2');
    this.suggestedEgridConnectionTime2 = getLeadCustomValueText(this.selectedLead, 'suggestedEgridConnectionTime2');
    this.egridConnectionActiveDate = getLeadCustomValueDate(this.selectedLead, 'egridConnectionActiveDate');

    this.praticaEnea = (getLeadCustomValueText(this.selectedLead, 'praticaEnea') ?? 'todo') as BoxStatusType;
    this.eneaPracticeDate = getLeadCustomValueDate(this.selectedLead, 'eneaPracticeDate');
    this.eneaElettricoNotes = getLeadCustomValueText(this.selectedLead, 'eneaElettricoNotes');
    this.eneaTermicoNotes = getLeadCustomValueText(this.selectedLead, 'eneaTermicoNotes');

    this.refreshAssignmentFields();

    // Dogane
    this.praticaDogane = (getLeadCustomValueText(this.selectedLead, 'praticaDogane') ?? 'todo') as BoxStatusType;
    this.doganeElettricoNotes = getLeadCustomValueText(this.selectedLead, 'doganeElettricoNotes');

    // Carica la configurazione degli assignment types se necessario
    if (this.$store.getters.getAssignmentTypes.length === 0) {
      this.$store.dispatch('fetchAssignmentTypes');
    }

    this.internetConnectionTested = getLeadCustomValueBoolean(this.selectedLead, 'internetConnectionTested') ?? false;
    this.serviceConfirm = getLeadCustomValueBoolean(this.selectedLead, 'serviceConfirm') ?? false;
    this.inverterConnected = getLeadCustomValueBoolean(this.selectedLead, 'inverterConnected') ?? false;
    this.commissioningNotes = getLeadCustomValueText(this.selectedLead, 'commissioningNotes');
    this.missingFinishingsStatus = getLeadCustomValueText(this.selectedLead, 'missingFinishingsStatus') as BoxStatusType | null;
    this.missingFinishingsNotes = getLeadCustomValueText(this.selectedLead, 'missingFinishingsNotes');

    // commissioning
    this.commissioningStatus = getLeadCustomValueText(this.selectedLead, 'commissioningStatus');
    this.commissioningDate = getLeadCustomValueDate(this.selectedLead, 'commissioningDate');
    this.commissioningStartTime = getLeadCustomValueText(this.selectedLead, 'commissioningStartTime');
    this.commissioningEndTime = getLeadCustomValueText(this.selectedLead, 'commissioningEndTime');

    // Verbale di allaccio

    this.verbaleAllaccio = (getLeadCustomValueText(this.selectedLead, 'verbaleAllaccio') ?? 'todo') as BoxStatusType;

    // Fine lavori

    this.titoloAutorizzativo = (this.selectedLead?.titoloAutorizzativo ?? 'todo') as BoxStatusType;

    this.endOfWork = (this.selectedLead?.endOfWork ?? 'todo') as BoxStatusType;
    this.endOfWorkNotes = getLeadCustomValueText(this.selectedLead, 'endOfWorkNotes');
    this.endOfWorkDate = this.selectedLead?.endOfWorkDate ?? null;

    this.apePost = getLeadCustomValueBoolean(this.selectedLead, 'apePost') ?? false;
    this.docsSentToPartner = getLeadCustomValueBoolean(this.selectedLead, 'docsSentToPartner') ?? false;
    this.docsSentToCustomer = getLeadCustomValueBoolean(this.selectedLead, 'docsSentToCustomer') ?? false;

    this.checkDate1Availability();
    this.checkDate2Availability();

    // Richiama il metodo implementato nel mixin
    return this.mixinRefreshTask();
  }

  async checkDate1Availability() {
    if (!this.suggestedEgridConnectionDate1 || !this.father) return;
    const counter: number = await this.$store.dispatch('checkDateAvailability', { id: this.father?.id, date: this.suggestedEgridConnectionDate1 }) ?? 0;
    this.suggestedDate1AppendIcon = counter > 0 ? 'mdi-calendar-alert' : false;
    this.suggestedDate1Hint = counter > 0 ? `Data proposta per altre ${counter} commesse` : null;
  }

  async checkDate2Availability() {
    if (!this.suggestedEgridConnectionDate2 || !this.father) return;
    const counter: number = await this.$store.dispatch('checkDateAvailability', { id: this.father?.id, date: this.suggestedEgridConnectionDate2 }) ?? 0;
    this.suggestedDate2AppendIcon = counter > 0 ? 'mdi-calendar-alert' : false;
    this.suggestedDate2Hint = counter > 0 ? `Data proposta per altre ${counter} commesse` : null;
  }

  get iter(): Iter { return (getLeadCustomValueText(this.selectedLead, 'iter') ?? null) as Iter; }

  get iterSemplificato(): boolean {
    return this.iter && this.iter === 's';
  }

  // I dati extra sono validi?
  get isExtraDataValid(): boolean {
    // Se è impossibile completare il task, i dati extra sono ignorati
    // FIXME: Rimuovere quando questo Task userà il mixin TaskMixin
    if (this.selectedStatus === 'error') return true;

    if (this.leadType === 'elettrica-figlia') {
      // Le 'elettrica-figlia' richiedono 'dicoElettrica', 'visura', 'autotest', 'fotoImpianto'

      // Le attività sono da fare o in attesa
      if (this.dicoElettrica === 'todo' || this.dicoElettrica === 'waiting') return false;
      if (this.visura === 'todo' || this.visura === 'waiting') return false;
      if (this.autotest === 'todo' || this.autotest === 'waiting') return false;
      if (this.fotoImpianto === 'todo' || this.fotoImpianto === 'waiting') return false;
      if (this.verbaleAllaccio === 'todo' || this.verbaleAllaccio === 'waiting') return false;

      // Le attività sono completate ma manca l'allegato
      if (this.dicoElettrica === 'done' && !this.hasAttachments('dicoElettrica')) return false;
      if (this.visura === 'done' && !this.hasAttachments('visura')) return false;
      if (this.autotest === 'done' && !this.hasAttachments('autotest')) return false;
      if (this.fotoImpianto === 'done' && !this.hasAttachments('fotoImpianto')) return false;
      if (this.verbaleAllaccio === 'done' && !this.hasAttachments('verbaleAllaccio')) return false;
    } else
    if (this.leadType === 'termica-figlia') {
      // Le 'elettrica-figlia' richiedono 'dicoTermica', 'registrazioneCriter', 'fGas',
      // 'fotoImpianto'

      // Le attività sono da fare o in attesa
      if (this.dicoTermica === 'todo' || this.dicoTermica === 'waiting') return false;
      if (this.registrazioneCriter === 'todo' || this.registrazioneCriter === 'waiting') return false;
      if (this.fGas === 'todo' || this.fGas === 'waiting') return false;
      if (this.fotoImpianto === 'todo' || this.fotoImpianto === 'waiting') return false;

      // Le attività sono completate ma manca l'allegato
      if (this.dicoTermica === 'done' && !this.hasAttachments('dicoTermica')) return false;
      if (this.registrazioneCriter === 'done' && !this.hasAttachments('registrazioneCriter')) return false;
      if (this.fGas === 'done' && !this.hasAttachments('fGas')) return false;
      if (this.fotoImpianto === 'done' && !this.hasAttachments('fotoImpianto')) return false;
    }

    // In tutti gli altri casi...
    return true;
  }

  get father(): Lead | null { return taskFatherLead(this.selectedTask); }

  get attachmentsVisible(): boolean {
    return this.leadType === 'elettrica-figlia'
      ? this.hasPermission('attachments.dicoElettrica.read')
        || this.hasPermission('attachments.visura.read')
        || this.hasPermission('attachments.autotest.read')
        || this.hasPermission('attachments.fotoImpianto.read')
      : this.hasPermission('attachments.dicoTermica.read')
        || this.hasPermission('attachments.registrazioneCriter.read')
        || this.hasPermission('attachments.fGas.read')
        || this.hasPermission('attachments.fotoImpianto.read');
  }

  get users(): User[] { return this.$store.getters.users; }

  get eneaAssigneeName(): string | null {
    if (!this.eneaAssigneeId) return null;
    const user = this.users.find((u) => u.id === this.eneaAssigneeId);
    return user?.name ?? null;
  }

  get eneaEntry(): AssignmentEntry {
    const config = this.$store.getters.getAssignmentType('enea');
    return {
      type: 'enea',
      label: config?.label || 'Assegnatario ENEA/GSE/Altro',
      icon: config?.icon || 'mdi-certificate',
      dateTooltip: 'Data assegnazione ENEA/GSE/Altro',
      permissionShow: 'eneaAssignment.show',
      permissionEdit: 'eneaAssignment.edit',
      multipleAssignees: false,
      assignees: [],
      assigneeId: this.eneaAssigneeId,
      assigneeName: this.eneaAssigneeName,
      assigned: this.eneaAssigned,
      assignedDate: this.eneaAssignedDate,
    };
  }

  get eneaAssignmentOperation(): Record<string, unknown> | null {
    const lead = this.selectedLead;
    if (!lead) return null;
    return {
      children: {
        [lead.id]: {
          type: this.leadType,
          eneaAssigneeId: this.eneaAssigneeId,
          eneaAssigned: this.eneaAssigned,
          eneaAssignedDate: this.eneaAssignedDate,
          eneaAssignees: this.eneaAssignees,
          firstTaskId: this.selectedTask?.id || null,
        },
      },
    };
  }

  onEditEneaAssignment() {
    if (!this.hasPermission('eneaAssignment.edit')) return;
    if (this.fieldsDisabled) return;
    this.editEneaAssignmentDialog = true;
  }

  // Dogane assignment

  get doganeAssigneeName(): string | null {
    if (!this.doganeAssigneeId) return null;
    const user = this.users.find((u) => u.id === this.doganeAssigneeId);
    return user?.name ?? null;
  }

  get doganeEntry(): AssignmentEntry {
    const config = this.$store.getters.getAssignmentType('dogane');
    return {
      type: 'dogane',
      label: config?.label || 'Assegnatario Dogane',
      icon: config?.icon || 'mdi-truck-fast-outline',
      dateTooltip: 'Data assegnazione Dogane',
      permissionShow: 'doganeAssignment.show',
      permissionEdit: 'doganeAssignment.edit',
      multipleAssignees: false,
      assignees: [],
      assigneeId: this.doganeAssigneeId,
      assigneeName: this.doganeAssigneeName,
      assigned: this.doganeAssigned,
      assignedDate: this.doganeAssignedDate,
    };
  }

  get doganeAssignmentOperation(): Record<string, unknown> | null {
    const lead = this.selectedLead;
    if (!lead) return null;
    return {
      children: {
        [lead.id]: {
          type: this.leadType,
          doganeAssigneeId: this.doganeAssigneeId,
          doganeAssigned: this.doganeAssigned,
          doganeAssignedDate: this.doganeAssignedDate,
          doganeAssignees: this.doganeAssignees,
          firstTaskId: this.selectedTask?.id || null,
        },
      },
    };
  }

  onEditDoganeAssignment() {
    if (!this.hasPermission('doganeAssignment.edit')) return;
    if (this.fieldsDisabled) return;
    this.editDoganeAssignmentDialog = true;
  }

  // Staged save dal dialog degli incarichi (modalità defer-save). Aggiorna i
  // campi locali reattivi letti da eneaEntry/doganeEntry e accumula il body
  // nel pendingUpdate del Task: verrà inviato al click di UpdateButton.
  onAssignmentSaved(payload: { body: Record<string, unknown> }) {
    const { body } = payload;

    if ('eneaAssigned' in body) {
      this.eneaAssigneeId = (body.eneaAssignee as number) ?? null;
      this.eneaAssigned = (body.eneaAssigned as string) ?? null;
      this.eneaAssignedDate = (body.eneaAssignedDate as Date) ?? null;
    }

    if ('doganeAssigned' in body) {
      this.doganeAssigneeId = (body.doganeAssignee as number) ?? null;
      this.doganeAssigned = (body.doganeAssigned as string) ?? null;
      this.doganeAssignedDate = (body.doganeAssignedDate as Date) ?? null;
    }

    this.$store.dispatch('updateTaskFields', body);
  }

  // Ritorna il testo relativo a egridConnectionStatus
  get egridConnectionStatusLong(): string | null {
    switch (this.egridConnectionStatus) {
      case 'not-confirmed':
        return 'Data di allacciamento non confermata';
      case 'confirmed':
        return 'Data di allacciamento confermata';
      case 'connected':
        return 'Impianto in esercizio';
      case 'ko':
        return 'Allacciamento KO da riprogrammare';
      default:
        return '';
    }
  }

  get commissioningDateLabel(): string {
    switch (this.commissioningStatus) {
      case 'suggested':
        return 'Data proposta';
      case 'confirmed':
        return 'Data confermata';
      case 'tested':
        return 'Data collaudo';
      default:
        return 'Data';
    }
  }

  get calendarUrl(): string {
    const token = this.currentUser?.iCalToken;

    // Ottiene l'URL del server corrente
    const url = window.location.host;

    // Ottiene il protocollo del server corrente (ad esempio "https:" o "http:")
    // eslint-disable-next-line prefer-destructuring
    const protocol = window.location.protocol;

    return `${protocol}//${url}/api/operations/calendar/${token}/commissioning`;
  }

  get showEgridConnectionPreviousDates(): boolean {
    switch (this.egridConnectionStatus) {
      case 'not-confirmed':
      case 'no-confirmation-required':
      case 'confirmed':
        return this.suggestedEgridConnectionDate1 !== null
          || this.suggestedEgridConnectionDate2 !== null;

      case 'connected':
      case 'ko':
        return this.suggestedEgridConnectionDate1 !== null
          || this.suggestedEgridConnectionDate2 !== null
          || this.egridConnectionDate !== null;

      case 'suggested':
      case 'na':
      default:
        return false;
    }
  }

  updateBoxStatus(name: string, status: BoxStatusType) {
    console.log(`${this.constructor.name}: updateBoxStatus(${name}, ${status})`); // eslint-disable-line no-console

    // Se lo stato non esiste si ferma subito
    if (name in this === false) { return; }

    this[name] = status;

    const update = {} as { [key: string]: unknown };

    update[name] = status;

    this.$store.dispatch('updateTaskFields', update);
  }

  updateBoxOutcome(outcome: BoxOutcomeType) {
    console.log(`${this.constructor.name}: updateBoxOutcome(${outcome})`); // eslint-disable-line no-console

    this.testingOutcome = outcome;

    const update = {} as { [key: string]: unknown };

    update.testingOutcome = outcome;

    this.$store.dispatch('updateTaskFields', update);
  }

  onSwitchChange(name: string) {
    console.log(`${this.constructor.name}: onSwitchChange(${name})`); // eslint-disable-line no-console

    // Se lo switch non esiste si ferma subito
    if (name in this === false) { return; }

    // Il valore del modello dello switch è già stato aggiornato.
    // Proseguo aggiornando eventuali valori collegati e preparo l'aggiornamento tramite API.

    const update = {} as { [key: string]: unknown };

    update[name] = this[name];

    // Modifico eventuali campi collegati
    switch (name) {
      case 'readyForSal1':
        if (this.readyForSal1) {
          this.readyForSal1Date = moment(moment(), 'YYYY-MM-DD').toDate();
          update.readyForSal1Date = this.readyForSal1Date;
        } else {
          this.readyForSal1Date = null;
          update.readyForSal1Date = null;
        }
        break;

      case 'readyForSal2':
        if (this.readyForSal2) {
          this.readyForSal2Date = moment(moment(), 'YYYY-MM-DD').toDate();
          update.readyForSal2Date = this.readyForSal2Date;
        } else {
          this.readyForSal2Date = null;
          update.readyForSal2Date = null;
        }
        break;

      case 'readyForFinalPayment':
        if (this.readyForFinalPayment) {
          this.readyForFinalPaymentDate = moment(moment(), 'YYYY-MM-DD').toDate();
          update.readyForFinalPaymentDate = this.readyForFinalPaymentDate;
        } else {
          this.readyForFinalPaymentDate = null;
          update.readyForFinalPaymentDate = null;
        }
        break;

      default:
        break;
    }

    this.$store.dispatch('updateTaskFields', update);
  }

  onClickDate(name: string, full = false) {
    console.log(`${this.constructor.name}: onClickDate(${name})`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open'
      || this.taskStatus !== null
      || this.readonly) return;

    // Imposta per quale campo verrà utilizzato il DatePicker
    this.datePickerName = name;

    // Imposta l'eventuale data precedentemente selezionata
    this.datePickerDate = this[name]
      ? moment(this[name]).toISOString(true).substring(0, 10)
      : null;

    // Resetto lo stato
    this.showBusyDatesType = null;

    // Imposta la proprietà per visualizzare le date impegnate
    switch (name) {
      case 'commissioningDate':
        this.showBusyDatesType = 'commissioning-full';
        break;

      case 'egridConnectionDate':
      case 'suggestedEgridConnectionDate1':
      case 'suggestedEgridConnectionDate2':
        this.showBusyDatesType = 'connection';
        break;

      default:
        this.showBusyDatesType = null;
        break;
    }

    // Apre il dialog per la selezione della data
    if (full) {
      this.fullDatePickerDialog = true;
    } else {
      this.datePickerDialog = true;
    }
  }

  onClearDate(name: string) {
    console.log(`${this.constructor.name}: onClearDate(${name})`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open') return;

    const update = {} as { [key: string]: unknown };

    // Cancello la data nel modulo e nel prossimo aggiornamento
    if (name in this) {
      this[name] = null;
      update[name] = null;
    }

    // Modifico eventuali campi collegati
    switch (name) {
      // Se è stato cancellata la data in testingDate...
      case 'testingDate':
        // ... deseleziona anche la sua conferma
        this.testingDateConfirm = false;
        update.testingDateConfirm = false;
        break;

      // Se è stato cancellata la data in egridConnectionDate...
      case 'egridConnectionDate':
        // ... deseleziona anche il suo stato ed elimina l'orario
        this.egridConnectionStatus = '';
        this.egridConnectionTime = '';
        update.egridConnectionStatus = '';
        update.egridConnectionTime = '';
        break;

      // Se è stato cancellata la data in suggestedEgridConnectionDate1...
      case 'suggestedEgridConnectionDate1':
        // ... elimina l'orario
        this.suggestedEgridConnectionTime1 = '';
        this.suggestedDate1AppendIcon = false;
        this.suggestedDate1Hint = null;
        update.suggestedEgridConnectionTime1 = '';
        break;

      // Se è stato cancellata la data in suggestedEgridConnectionDate2...
      case 'suggestedEgridConnectionDate2':
        // ... elimina l'orario
        this.suggestedEgridConnectionTime2 = '';
        this.suggestedDate2AppendIcon = false;
        this.suggestedDate2Hint = null;
        update.suggestedEgridConnectionTime2 = '';
        break;

      default:
        break;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  get commissioningStartTimeFormat() {
    // formatta l'orario in HH:mm o in HH mm o in HH.mm o HH,mm o con spazi iniziali o finali
    return /^\s*([01]?\d|2[0-3])[.:\s,]?([0-5]\d)\s*$/;
  }

  get commissioningStartTimeRules() {
    return [
      (v: string) => !!v || "L'orario di inizio è richiesto",
      (v: string) => this.commissioningStartTimeFormat
        .test(v) || "L'orario non è in formato corretto",
    ];
  }

  onBlurTime() {
    console.log(`${this.constructor.name}: onBlurTime()`); // eslint-disable-line no-console

    // se l'orario è valido correggo eventualmente il formato in HH:mm
    if (this.commissioningStartTime
      && this.commissioningStartTimeFormat.test(this.commissioningStartTime)) {
      const match = this.commissioningStartTime.match(this.commissioningStartTimeFormat);
      const hours = match && 1 in match ? match[1] : null;
      const minutes = match && 2 in match ? match[2] : null;
      if (hours && minutes) {
        this.commissioningStartTime = `${hours.padStart(2, '0')}:${minutes}`;
      }

      // ho aggiornato il formato e aggiorno il campo
      this.onFieldUpdated('commissioningStartTime');
    }
  }

  onInputTime() {
    console.log(`${this.constructor.name}: onChangeTime()`); // eslint-disable-line no-console

    // se l'orario è valido aggiorno l'orario di fine
    if (this.commissioningStartTime
      && this.commissioningStartTimeFormat.test(this.commissioningStartTime)) {
      const match = this.commissioningStartTime.match(this.commissioningStartTimeFormat);
      const hours = match && 1 in match ? match[1] : null;
      const minutes = match && 2 in match ? match[2] : null;
      if (hours && minutes) {
        let endHours = parseInt(hours, 10) + 2;
        if (endHours > 23) {
          endHours -= 24;
        }
        const endHoursString = `${endHours}`.padStart(2, '0');
        this.commissioningEndTime = `${endHoursString}:${minutes}`;
      }
    } else {
      this.commissioningEndTime = null;
    }
    this.onFieldUpdated('commissioningStartTime');
  }

  onClearTime(name: string) {
    console.log(`${this.constructor.name}: onClearTime()`); // eslint-disable-line no-console

    if (this.leadStatus !== 'open') return;

    const update = {} as { [key: string]: unknown };

    // Cancello la data nel modulo e nel prossimo aggiornamento
    if (name in this) {
      this[name] = null;
      update[name] = null;
    }

    // Modifico eventuali campi collegati
    switch (name) {
      // Se è stato cancellato l'orario in commissioningStartTime...
      case 'commissioningStartTime':
        // ... cancella anche il campo commissioningEndTime
        this.commissioningEndTime = null;
        update.commissioningEndTime = null;
        break;

      default:
        break;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  onSelectDate(date: string | null) {
    console.log(`${this.constructor.name}: onSelectDate() date =`, date); // eslint-disable-line no-console

    if (!this.datePickerName) return;

    // Chiudo il dialog per la selezione della data
    this.datePickerDialog = false;

    const update = {} as { [key: string]: unknown };

    // Trasforma in un valore di tipo Date prima di restituirlo
    const selectedDate = date
      ? moment(date, 'YYYY-MM-DD').toDate()
      : null;

    // Inserisco la data nel modulo e nell'aggiornamento
    if (this.datePickerName in this) {
      this[this.datePickerName] = selectedDate;
      update[this.datePickerName] = this[this.datePickerName];
    }

    // Modifico eventuali campi collegati
    switch (this.datePickerName) {
      // Se è stata modificata la data in testingDate...
      case 'testingDate':
        // ... deseleziona anche la sua conferma
        this.testingDateConfirm = false;
        update.testingDateConfirm = false;
        break;

      case 'suggestedEgridConnectionDate1': {
        this.checkDate1Availability();
        break;
      }

      case 'suggestedEgridConnectionDate2': {
        this.checkDate2Availability();
        break;
      }

      default:
        break;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  onSelectDateAndTime(date: string | null, startTime: string | null, endTime: string | null) {
    console.log(`${this.constructor.name}: onSelectDateAndTime() date =`, date, 'startTime =', startTime, 'endTime =', endTime); // eslint-disable-line no-console

    if (!this.datePickerName) return;

    // Chiudo il dialog per la selezione della data
    this.fullDatePickerDialog = false;

    const update = {} as { [key: string]: unknown };

    // Trasforma in un valore di tipo Date prima di restituirlo
    const selectedDate = date
      ? moment(date, 'YYYY-MM-DD').toDate()
      : null;

    // Inserisco la data nel modulo e nell'aggiornamento
    if (this.datePickerName in this) {
      this[this.datePickerName] = selectedDate;
      update[this.datePickerName] = this[this.datePickerName];
    }

    // Modifico eventuali campi collegati
    switch (this.datePickerName) {
      // Se è stata modificata la data in commissioningDate...
      case 'commissioningDate':
        // ... aggiorna anche l'orario di inizio e fine
        this.commissioningStartTime = startTime;
        update.commissioningStartTime = startTime;
        this.commissioningEndTime = endTime;
        update.commissioningEndTime = endTime;
        break;
      default:
        break;
    }

    // Valido il modulo con le nuove informazioni inserite
    this.onValidate('completed');

    this.$store.dispatch('updateTaskFields', update);
  }

  onMissingFinishingsStatusUpdate(val: BoxStatusType | null) {
    this.missingFinishingsStatus = val;
    this.onFieldUpdated('missingFinishingsStatus');
  }

  onMissingFinishingsNotesUpdate(val: string) {
    this.missingFinishingsNotes = val;
    this.onFieldUpdated('missingFinishingsNotes');
  }

  onFieldUpdated(field: string) {
    console.log(`${this.constructor.name}: onFieldUpdated(${field})`); // eslint-disable-line no-console

    const update = {} as { [key: string]: unknown };

    // Aggiorna sempre il campo specificato
    update[field] = this[field] ?? '';

    // Aggiorna eventuali campi collegati, eccezioni, ecc.
    switch (field) {
      // Se è stato modificato egridConnectionStatus...
      case 'egridConnectionStatus':
        // ... e non è stato impostato un valore...
        if (!this.egridConnectionStatus) {
          // ... resetta tutte le date
          this.suggestedEgridConnectionDate1 = null;
          this.suggestedEgridConnectionTime1 = null;
          this.suggestedEgridConnectionDate2 = null;
          this.suggestedEgridConnectionTime2 = null;
          this.egridConnectionDate = null;
          this.egridConnectionTime = null;
          this.egridConnectionActiveDate = null;
          update.suggestedEgridConnectionDate1 = null;
          update.suggestedEgridConnectionTime1 = null;
          update.suggestedEgridConnectionDate2 = null;
          update.suggestedEgridConnectionTime2 = null;
          update.egridConnectionDate = null;
          update.egridConnectionTime = null;
          update.egridConnectionActiveDate = null;
        } else if (this.egridConnectionStatus === 'suggested') {
          // Se è stato impostato a 'suggested' resetta le date successive
          this.egridConnectionDate = null;
          this.egridConnectionTime = null;
          this.egridConnectionActiveDate = null;
          update.egridConnectionDate = null;
          update.egridConnectionTime = null;
          update.egridConnectionActiveDate = null;
        } else if (this.egridConnectionStatus === 'connected') {
          // imposta la egridConnectionActiveDate alla data odierna
          this.egridConnectionActiveDate = moment(moment(), 'YYYY-MM-DD').toDate();
          update.egridConnectionActiveDate = this.egridConnectionActiveDate;
        }
        break;

      case 'commissioningStartTime':
        if (this.commissioningStartTime) {
          update.commissioningEndTime = this.commissioningEndTime;
        } else {
          update.commissioningEndTime = null;
        }
        break;

      default:
        break;
    }

    this.$store.dispatch('updateTaskFields', update);
  }

  // Effetta la validazione del modulo
  async onValidate(status: 'completed' | 'error') {
    console.log(`${this.constructor.name}: onValidate(${status})`); // eslint-disable-line no-console

    // Sceglie se validare il modulo per un completamento o per un fallimento
    this.selectedStatus = status;

    // Avvia l'effettiva validazione
    const form = this.$refs.form as Vue & {
      validate: () => boolean;
      reset: () => boolean;
    };

    if (form) {
      const result = form.validate();
      console.log(`${this.constructor.name}: onValidate() form.validate() =`, result); // eslint-disable-line no-console
    } else {
      console.error(`${this.constructor.name}: onValidate() form =`, form); // eslint-disable-line no-console
      console.error(`${this.constructor.name}: onValidate() this.$refs =`, this.$refs); // eslint-disable-line no-console
    }

    return Promise.resolve();
  }
}
